import { Button } from "components/DesignSystem/Button/Button";
import { LoadingIcon } from "components/icons/LoadingIcon";
import { PriceTagOutline } from "components/icons/PriceTagOutline";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useDispatch } from "react-redux";
import { openDocumentTagReviewModal } from "store/slices/documentTagReviewModal";
import { MessageCustomData } from "types/Models/Chat";

type DocumentTagStatusRowProps = {
  documentTagging: MessageCustomData["document_tagging"];
  messageId: string;
  channelId?: string;
  groupId: string;
};

export const DocumentTagStatusRow = ({
  documentTagging,
  messageId,
  channelId,
  groupId,
}: DocumentTagStatusRowProps) => {
  const dispatch = useDispatch();
  const { isCpa, isAdmin } = useRoleBasedView();
  const canManageTags = isCpa || isAdmin;

  if (!documentTagging || !canManageTags) {
    return null;
  }

  const {
    is_tagging: isTagging,
    tagged_count: taggedCount,
    total_count: totalCount,
  } = documentTagging;

  const onViewClick = () => {
    dispatch(openDocumentTagReviewModal({ channelId, groupId, messageId }));
  };

  if (isTagging) {
    return (
      <div className="t-flex t-items-center t-gap-1 t-mt-1 t-text-body-sm-italic t-text-text-30 t-italic">
        <span className="t-flex t-items-center t-animate-spin t-text-purple">
          <LoadingIcon />
        </span>
        <span>Tagging {totalCount} documents</span>
      </div>
    );
  }

  if (taggedCount === 0) {
    <div className="t-flex t-items-center t-gap-1 t-mt-1 t-text-body-sm-italic t-text-text-30 t-italic">
      <PriceTagOutline />
      <span>No tags suggested for uploaded document</span>
      <Button customType="link" size="small" onClick={onViewClick}>
        Add tags
      </Button>
    </div>;
  }

  return (
    <div className="t-flex t-items-center t-gap-1 t-mt-1 t-text-body-sm-italic t-text-text-30 t-italic">
      <PriceTagOutline />
      <span>
        {taggedCount}/{totalCount} documents are tagged &amp; sorted.
      </span>
      <Button customType="link" size="small" onClick={onViewClick}>
        View
      </Button>
    </div>
  );
};
